import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { AlertTriangle, ExternalLink, Loader2 } from 'lucide-react';

// Red banner for past due payment
const PastDueBanner = ({ daysPastDue, onResolve }) => {
  const t = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleResolveClick = async (e) => {
    e.preventDefault();
    if (!onResolve) return;
    
    setIsLoading(true);
    try {
      await onResolve();
      // If we get here without redirect, something went wrong
      setTimeout(() => {
        // Set a timeout to reset in case the redirect doesn't happen
        setIsLoading(false);
      }, 5000);
    } catch (error) {
      console.error('Error resolving payment:', error);
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-gradient-to-r from-red-600 to-red-800 text-white w-full">
      <div className="flex items-center justify-between px-4 py-2 relative">
        {/* Empty div for alignment */}
        <div className="w-8"></div>
        {/* Centered message */}
        <div className="flex items-center justify-center">
          <AlertTriangle className="w-4 h-4 mr-2 flex-shrink-0 text-yellow-300" />
          <span className="text-sm font-medium">
            {t('pastdue.banner', { days: daysPastDue })}
          </span>
          <a
            href="#"
            className={`ml-2 text-xs sm:text-sm font-medium flex items-center hover:underline text-white ${isLoading ? 'opacity-50 pointer-events-none' : ''}`}
            onClick={handleResolveClick}
            aria-disabled={isLoading}
          >
            {isLoading 
              ? <span className="flex items-center"><Loader2 className="w-3 h-3 mr-1 animate-spin" />{t('common.loading')}</span>
              : t('pastdue.resolve')}
            {!isLoading && <ExternalLink className="w-3 h-3 ml-1" />}
          </a>
        </div>
        {/* Empty div for alignment */}
        <div className="w-8"></div>
      </div>
    </div>
  );
};

export default PastDueBanner; 